import { prepareManifestForEditor } from "components/FormerEditor/common";
import {
  generateVariableSet,
  getHydratedVariables
} from "components/FormerEditor/common/template";

import ENTITIES from "components/FormerEditor/common/constants/entity";
import {
  RiPercentLine,
  RiAlarmWarningLine,
  RiShieldCheckLine,
  RiMapPinLine,
  RiCoupon3Line,
  RiStopLine,
  RiCheckboxMultipleLine,
  RiDeleteBin7Line,
  RiTableLine,
  RiPencilLine,
  RiMoreFill,
  RiSettingsLine,
  RiCloseLine,
  RiFlag2Line,
  RiAddLine,
  RiArrowLeftLine,
  RiCodeSSlashLine,
  RiClipboardLine,
  RiEdit2Line,
  RiEyeLine,
  RiEyeOffLine,
  RiFlashlightLine,
  RiAlertLine,
  RiFileListLine,
  RiArrowDownSLine,
  RiInformationLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
  RiMoreLine,
  RiStarLine,
  RiRefreshLine,
  RiSearchLine,
  RiSettings2Line,
  RiPaletteLine,
  RiPriceTag3Line,
  RiPriceTag3Fill,
  RiMedalLine,
  RiMoneyDollarBoxLine,
  RiCalendarEventLine,
  RiCalendarCheckLine,
  RiGroupLine,
  RiDragDropLine,
  RiUserLine,
  RiCalculatorLine,
  RiLineChartLine,
  RiStickyNoteLine,
  RiHome4Line,
  RiBarChartBoxLine,
  RiLinksFill,
  RiDatabase2Line,
  RiLayoutGridLine,
  RiMenu2Line,
  RiCheckboxCircleLine,
  RiStore2Line,
  RiBankLine,
  RiGlobalLine,
  RiTimerLine,
  RiQrCodeLine,
  RiQrScan2Line,
  RiArrowRightLine,
  RiLock2Line,
  RiImageAddLine,
  RiUploadCloud2Line,
  RiQuestionLine
} from "react-icons/ri";
// import { AiOutlineNotification } from "react-icons/ai";
import { VscMegaphone } from "react-icons/vsc";

import { IoIosCheckmarkCircle, IoIosWarning, IoMdOpen } from "react-icons/io";
import { FaShippingFast } from "react-icons/fa";
import { STATE_KEYS } from "utils/constants/state";
import { BUILDER_INTENT } from "utils/constants/builder";
import get from "lodash/get";
import { RECURRING_INTERVALS } from "./common/constants";
import { HUB_APP_SUB_SECTION } from "utils/constants/navigation";

const PAGE_BUILDER = "page-builder";
const SETTINGS = "settings";
const FEATURES = "features";
const PRODUCTS = "products";

export const SECTIONS = {
  PAGE_BUILDER,
  SETTINGS,
  FEATURES,
  PRODUCTS
};

/**
 * Source documentation:
 * https://react-icons.github.io/react-icons/icons?name=ri
 */
const ICON_MAP = {
  [ENTITIES.NAVIGATION]: RiMapPinLine,
  [ENTITIES.FOOTER]: RiStopLine,
  [ENTITIES.BANNER]: RiFlag2Line,
  [ENTITIES.PRICING_TABLE]: RiTableLine,
  [ENTITIES.FEATURE_COMPARISON]: RiCheckboxMultipleLine,
  [SECTIONS.PAGE_BUILDER]: RiPencilLine,
  [SECTIONS.SETTINGS]: RiSettingsLine,
  [SECTIONS.FEATURES]: RiFileListLine,
  [SECTIONS.PRODUCTS]: RiPriceTag3Line,
  [RECURRING_INTERVALS.MONTH]: RiCalendarEventLine,
  [RECURRING_INTERVALS.YEAR]: RiCalendarCheckLine,
  application: RiDatabase2Line,
  coupons: RiCoupon3Line,
  upload: RiUploadCloud2Line,
  discount: RiPriceTag3Fill,
  medal: RiMedalLine,
  shield: RiShieldCheckLine,
  gear: RiSettings2Line,
  search: RiSearchLine,
  grid: RiLayoutGridLine,
  list: RiMenu2Line,
  checkmark: IoIosCheckmarkCircle,
  checkmarkCircle: RiCheckboxCircleLine,
  refresh: RiRefreshLine,
  close: RiCloseLine,
  addImage: RiImageAddLine,
  external: IoMdOpen,
  delete: RiDeleteBin7Line,
  help: RiInformationLine,
  question: RiQuestionLine,
  add: RiAddLine,
  down: RiArrowDownSLine,
  right: RiArrowRightSLine,
  rightArrow: RiArrowRightLine,
  up: RiArrowUpSLine,
  dragDrop: RiDragDropLine,
  back: RiArrowLeftLine,
  code: RiCodeSSlashLine,
  copy: RiClipboardLine,
  edit: RiEdit2Line,
  eye: RiEyeLine,
  eyeClosed: RiEyeOffLine,
  star: RiStarLine,
  lock: RiLock2Line,
  flash: RiFlashlightLine,
  alert: RiAlertLine,
  more: RiMoreLine,
  theme: RiPaletteLine,
  dollar: RiMoneyDollarBoxLine,
  sales: RiMoneyDollarBoxLine,
  store: RiStore2Line,
  bank: RiBankLine,
  globe: RiGlobalLine,
  individual: RiUserLine,
  group: RiGroupLine,
  calculator: RiCalculatorLine,
  warning: IoIosWarning,
  alarm: RiAlarmWarningLine,
  chart: RiBarChartBoxLine,
  link: RiLinksFill,
  taxRates: RiPercentLine,
  fallback: RiMoreFill,
  time: RiTimerLine,
  qrCode: RiQrCodeLine,
  scan: RiQrScan2Line,
  shipping: FaShippingFast,
  [HUB_APP_SUB_SECTION.ANALYTICS]: RiLineChartLine,
  [HUB_APP_SUB_SECTION.PAGES]: RiStickyNoteLine,
  [HUB_APP_SUB_SECTION.HOME]: RiHome4Line,
  [HUB_APP_SUB_SECTION.LINKS]: RiLinksFill,
  [HUB_APP_SUB_SECTION.FILES]: RiUploadCloud2Line,
  [HUB_APP_SUB_SECTION.CAMPAIGNS]: VscMegaphone,
  // [HUB_APP_SUB_SECTION.CAMPAIGNS]: AiOutlineNotification,
  link_builder: RiLinksFill,
  page_builder: RiStickyNoteLine
};

export const getIconForUID = (uid) => {
  let icon = ICON_MAP[uid];
  if (!icon) {
    if (process.env.NODE_ENV === "development") {
      console.log(`[WARN]: No icon found for ${uid}`);
    }
    icon = ICON_MAP.fallback;
  }
  return icon;
};

export const getEditorInitialValues = ({
  manifest,
  admin,
  theme,
  products,
  prices,
  features,
  featureGroups,
  appEntities,
  variables
}) => {
  const input = {
    manifest,
    admin,
    products,
    prices,
    features,
    featureGroups,
    appEntities
  };

  const generatedVariables = generateVariableSet({
    persisted: variables,
    template: [],
    product: products,
    price: prices
  });

  const hydratedVariables = getHydratedVariables(generatedVariables, {
    product: products,
    price: prices
  });
  const isBlank = get(input, STATE_KEYS.MANIFEST.ENTITIES, []).length === 0;

  const preparedManifest = prepareManifestForEditor(input);

  return {
    editor: {
      intent: isBlank ? BUILDER_INTENT.ENTITY_ADD : null,
      activeSection: SECTIONS.PAGE_BUILDER,
      activeBlock: null,
      visibility: {
        panel: !!isBlank
      },
      pricing: {
        activeProduct: null,
        activePrice: null,
        intent: null
      },
      feature: {
        activeProduct: null,
        intent: null
      }
    },
    manifest: preparedManifest,
    theme: theme,
    variables: hydratedVariables
  };
};
